import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    layoutName: 'default',
    activeTitle: '',
    isLoading: true,
    sDefaults: {tab: 'active'},
    localitiesMaster: [],
    CampaignTypesMaster: [],
    statusesMaster: [],
    EnquirystatusesMaster: [],
    ProjectsMaster: [],
    EnquirySourcesMaster: [],
    brokersMaster: [],
    AssignedToMaster: [],
    DeadReasonMaster: [],
    FieldExecutiveMaster: [],
    EnquiriesadvSParams: {},
    Performance: [],
    BuildingBrokerStatus: [],
    TeamLeads: [],
    BrokersFirmName: [],
    MeetingTypes: [],
    campaign_status: [],
    broker_categorization: [],
    cpSettings:{},
    can_create: false,
    isDailyMeeting: 'no',
    StandupTypeMaster:[],
    premium_enq_projects: [],
    premium_enq_statuses: [],
    brokers_uuids: [],
    is_manager: ''
  },
  mutations: {
    setLayout(state, layout){
      state.layoutName = layout
    },
    setActiveTitle(state, title){
      state.activeTitle = title
    },
    setLocalitiesMaster(state, localities){
      state.localitiesMaster = localities
    },
    setCampaignTypesMaster(state, campaign_types){
      state.CampaignTypesMaster = campaign_types
    },
    setStandupType(state, standup_types){
      state.StandupTypeMaster = standup_types
    },
    setStatusesMaster(state, statuses){
      state.statusesMaster = statuses
    },
    setEnquiryStatusesMaster(state, enquirystatuses){
      state.EnquirystatusesMaster = enquirystatuses
    },
    setProjectsMaster(state, projects){
      state.ProjectsMaster = projects
    },
    setEnquirySourcesMaster(state, enquiry_sources){
      state.EnquirySourcesMaster = enquiry_sources
    },
    setbrokersMaster(state, brokers){
      state.brokersMaster = brokers
    },
    setAssignedToMaster(state, assigned_to){
      state.AssignedToMaster = assigned_to
    },
    setDeadReasonToMaster(state, dead_reasons){
      state.DeadReasonMaster = dead_reasons
    },
    setFieldExecutiveMaster(state, field_executives){
      state.FieldExecutiveMaster = field_executives
    },
    setPerformance(state, performance){
      state.Performance = performance
    },
    setBuildingBrokerStatus(state, statuses_building_broker){
      state.BuildingBrokerStatus = statuses_building_broker
    },
    setLoading(state, isLoading){
      state.isLoading = isLoading
    },
    setEnquiriesAdvSParams(state, sParams){
      state.EnquiriesadvSParams = sParams;
    },
    setTeamLeadMaster(state, team_leads){
      state.TeamLeads = team_leads;
    },
    setBrokersFirmNameMaster(state,brokers){
      state.BrokersFirmName = brokers;
    },
    setMeetingTypesMaster(state, meetingTypes){
      state.MeetingTypes = meetingTypes;
    },
    setCampaignStatus(state, status){
      state.campaign_status = status;
    },
    setBrokerCategorization(state, br) {
      state.broker_categorization = br;
    },
    setCPSettings(state,cpSettings){
      state.cpSettings = cpSettings;
    },
    setPremiumEnquiryProjects(state,prprojects){
      state.premium_enq_projects = prprojects;
    },
    setPremiumEnquiryStatus(state,enq_status){
      state.premium_enq_statuses = enq_status;
    },
    setBrokerUUId(state,broker_uuid){
      state.brokers_uuids = broker_uuid;
    },
    setIsManager(state,manager){
      state.is_manager = manager;
    },
  },
  actions: {
    setLayout({commit}, layout){
      commit('setLayout', layout);
    },
    setActiveTitle({commit}, title){
      commit('setActiveTitle', title);
    },
    setLocalitiesMaster({commit}, localities){
      commit('setLocalitiesMaster', localities)
    },
    setCampaignTypesMaster({commit}, campaign_types){
      commit('setCampaignTypesMaster', campaign_types)
    },
    setStandupType({commit}, standup_types){
      commit('setStandupType', standup_types)
    },
    setStatusesMaster({commit}, statuses){
      commit('setStatusesMaster', statuses)
    },
    setEnquiryStatusesMaster({commit}, enquirystatuses){
      commit('setEnquiryStatusesMaster', enquirystatuses)
    },
    setProjectsMaster({commit}, projects){
      commit('setProjectsMaster', projects)
    },
    setEnquirySourcesMaster({commit}, enquiry_sources){
      commit('setEnquirySourcesMaster', enquiry_sources)
    },
    setbrokersMaster({commit}, brokers){
      commit('setbrokersMaster', brokers)
    },
    setAssignedToMaster({commit}, assigned_to){
      commit('setAssignedToMaster', assigned_to)
    },
    setDeadReasonToMaster({commit}, dead_reasons){
      commit('setDeadReasonToMaster', dead_reasons)
    },
    setFieldExecutiveMaster({commit}, field_executives){
      commit('setFieldExecutiveMaster', field_executives)
    },
    setPerformance({commit}, performance){
      commit('setPerformance', performance)
    },
    setBuildingBrokerStatus({commit}, statuses_building_broker){
      commit('setBuildingBrokerStatus', statuses_building_broker)
    },
    setLoading({commit}, isLoading){
      commit('setLoading', isLoading);
    },
    setEnquiriesAdvSParams({commit}, sParams){
      commit('setEnquiriesAdvSParams', sParams);
    },
    setTeamLeadMaster({commit}, team_leads){
      commit('setTeamLeadMaster', team_leads);
    },
    setBrokersFirmNameMaster({commit},brokers){
      commit('setBrokersFirmNameMaster',brokers);
    },
    setMeetingTypesMaster({commit},meetingTypes){
      commit('setMeetingTypesMaster',meetingTypes);
    },
    setCampaignStatus({commit},status){
      commit('setCampaignStatus',status);
    },
    setBrokerCategorization({commit},br){
      commit('setBrokerCategorization',br);
    },
    setCPSettings({commit},cpSettings){
      commit('setCPSettings',cpSettings);
    },
    setPremiumEnquiryProjects({commit},prprojects){
      commit('setPremiumEnquiryProjects',prprojects);
    },
    setCPSettings({commit},cpSettings){
      commit('setCPSettings',cpSettings);
    },
    setPremiumEnquiryStatus({commit},enq_status){
      commit('setPremiumEnquiryStatus',enq_status);
    },
    setBrokerUUId({commit},broker_uuid){
      commit('setBrokerUUId',broker_uuid);
    },
    setIsManager({commit},manager){
      commit('setIsManager',manager);
    },
  },
  getters: {
    layout(state){
      return state.layoutName;
    },
    activeTitle(state){
      return state.activeTitle;
    },
    sDefaults(state){
      return state.sDefaults;
    },
    localitiesMaster(state){
      return state.localitiesMaster;
    },
    CampaignTypesMaster(state){
      return state.CampaignTypesMaster;
    },
    standupTypeMaster(state){
      return state.StandupTypeMaster;
    },
    statusesMaster(state){
      return state.statusesMaster;
    },
    EnquirystatusesMaster(state){
      return state.EnquirystatusesMaster;
    },
    ProjectsMaster(state){
      return state.ProjectsMaster;
    },
    EnquirySources(state){
      return state.EnquirySourcesMaster;
    },
    brokersMaster(state){
      return state.brokersMaster;
    },
    AssignedToMaster(state){
      return state.AssignedToMaster;
    },
    DeadReasonMaster(state){
      return state.DeadReasonMaster;
    },
    FieldExecutiveMaster(state){
      return state.FieldExecutiveMaster;
    },
    Performance(state){
      return state.Performance;
    },
    BuildingBrokerStatus(state){
      return state.BuildingBrokerStatus;
    },
    isLoading(state){
      return state.isLoading;
    },
    EnquiriesadvSParams(state){
      return state.EnquiriesadvSParams;
    },
    TeamLeadMaster(state){
      return state.TeamLeads;
    },
    BrokersFirmNameMaster(state){
      return state.BrokersFirmName;
    },
    MeetingTypesMaster(state){
      return state.MeetingTypes;
    },
    campaign_status(state){
      return state.campaign_status;
    },
    broker_categorization(state){
      return state.broker_categorization;
    },
    cpSettings(state){
      return state.cpSettings;
    },
    premium_enq_projects(state){
      return state.premium_enq_projects;
    },
    premium_enq_statuses(state){
      return state.premium_enq_statuses;
    },
    brokers_uuids(state){
      return state.brokers_uuids;
    },
    is_manager(state){
      return state.is_manager;
    },
  }
})
